export function panTo(coordinates, isProgrammaticPan = false) {
  return dispatch => {
    dispatch({
      type: 'PAN_TO', 
      payload: {
        center: coordinates, 
        isProgrammaticPan: isProgrammaticPan
      }
    })
  }
}



export function setClickedMarkerData(data) {
  return dispatch => {
    dispatch({type: 'SET_CLICKED_MARKER_DATA', payload: data})
  }
}



export function addUserMarker(marker) {
  return dispatch => {
    dispatch({type: 'SET_USER_MARKER', payload: marker})
  }
}



export function resetClickedMarker() {
  return dispatch => {
    dispatch({type: 'RESET_CLICKED_MARKER_DATA'})
  }
}